
 
 function ViewAuthorSubmission() {
 return(
<div  className="App">
<h3 className="">Your Submitted Manuscripts</h3>
                    <p className="">
                  <strong> </strong><br/>Title of Manuscript Here
                    </p>
                  <p className="">
                        <span className="">Status </span> : <u>Awaiting Review</u>
                    </p>
              
             
              
              
              </div>
 )
}
export default ViewAuthorSubmission;